import React from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUserStore } from '../../store';

/**
 * Shown ONLY to trial organizations, on features the trial grants at Perus level
 * (tire hotel, online booking, AI work order drafts): makes clear the feature is
 * kept only on Perus and higher, so nobody is surprised after picking Aloitus.
 * Renders nothing for orgs with a real subscription.
 */
function TrialFeatureNotice({ sx }) {
  const { t } = useTranslation();
  const { currentOrganization } = useUserStore();

  if (!currentOrganization?.subscription_status?.is_trial) {
    return null;
  }

  return (
    <Alert severity="info" sx={{ mb: 2, ...sx }}>
      {t('trialFeatureNotice.perusFeature')}
    </Alert>
  );
}

export default TrialFeatureNotice;
